import { Paragraph } from '../Paragraph';
import cn from 'classnames';
import classes from './Label.module.css';

type LabelProps = {
  label: string;
  htmlFor: string;
  required?: boolean;
  size: 'sm' | 'md' | 'ml' | 'lg';
  spacing?: boolean;
};

export const Label = ({
  label,
  htmlFor,
  required,
  size,
  spacing = true,
}: LabelProps) => {
  const classNames = cn(classes.label, {
    [classes.spacing]: spacing,
  });
  return (
    <label htmlFor={htmlFor} className={classNames}>
      <Paragraph size={size} as="span">
        {label}
      </Paragraph>
      {required && (
        <Paragraph as="span" className={classes.required} size={size}>
          *
        </Paragraph>
      )}
    </label>
  );
};
